import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { LayoutHeader } from '@folio/stripes-components';
import styles from '../styles.css';

function SourceDescription({ selectedTemplate, isLocalizedDesc }) {
  const intl = useIntl();

  const localizedDesc = isLocalizedDesc
    ? selectedTemplate?.description?.find((field) => field?.locale === intl.locale)?.value
    : selectedTemplate?.description;

  return (
    <div>
      <LayoutHeader
        title={
          <FormattedMessage
            id="ui-plugin-inventory-templates.addNewModal.descSection.label"
            defaultMessage="Template Description"
          />
        }
        noActions
      />
      <div className={styles.template_desc}>
        {localizedDesc}
      </div>
    </div>
  );
}

SourceDescription.propTypes = {
  selectedTemplate: PropTypes.object,
  isLocalizedDesc: PropTypes.bool,
};

export default SourceDescription;
